export interface IInvoicingInformation {
  name: String
  address: String
  accountNumber: String
  accountName: String
  swiftCode: String
  taxNumber: String
  phone: String
}
const rulesInvoice = {
  name: 'required',
  address: 'required',
  accountNumber: 'required',
  accountName: 'required',
  swiftCode: 'required',
  taxNumber: 'required',
  phone: 'required'
}

const initInvoice = {
  name: '',
  address: '',
  accountNumber: '',
  accountName: '',
  swiftCode: '',
  taxNumber: '',
  phone: ''
}

export default {
  rulesInvoice,
  initInvoice
}
